import React from "react";
import { SeoRegistryContext, createSeoRegistry } from "./registry";

export default function SeoRegistryProvider({ registry, children }) {
  const fallback = React.useRef(null);
  if (!registry && !fallback.current) fallback.current = createSeoRegistry();
  return (
    <SeoRegistryContext.Provider value={registry || fallback.current}>
      {children}
    </SeoRegistryContext.Provider>
  );
}
